import React from 'react';

import { Nullable } from '@clearverify/types';

import { useConfirmUserEmailMutation } from 'src/api';

import { useNotification } from '../app';

export const useUserEmailChangeRequestById = (userEmailChangeRequestId: Nullable<string>) => {
  const { createApolloContext } = useNotification();

  const [confirmUserEmailMutation, { loading }] = useConfirmUserEmailMutation();

  const confirmUserEmail = React.useCallback(async () => {
    if (!userEmailChangeRequestId) return;

    await confirmUserEmailMutation({
      variables: {
        userEmailChangeRequestId,
      },
      context: createApolloContext({
        successMessage: 'Email Confirmed Successfully!',
        errorMessage: 'Email not confirmed',
      }),
    });
  }, [confirmUserEmailMutation, createApolloContext, userEmailChangeRequestId]);

  return {
    confirmUserEmail,
    loading,
  };
};
